import {
  types,
  // getParent
} from 'mobx-state-tree';

const SanityCheck = types.model('SanityCheck', {
  sanityCheckId: types.optional(types.string, ''),
  statusColor: types.optional(types.string, ''),
  statusType: types.optional(
    types.union(
      types.literal(0),
      types.literal(1),
      types.literal(2),
      types.literal(3)
    ),
    1
  ),
  sanityCheckName: types.optional(types.string, ''),
  statusError: types.optional(types.string, ''),
})

export default SanityCheck;
